import rp from 'request-promise';

export default class Gatekeeper {

  constructor(user, endpoints, orderId) {
    this.user = user;
    this.endpoints = endpoints;
    this.orderId = orderId;
    if (/^O_/.exec(String(this.orderId))) {
      this.headers = {};
      this.uri = this.endpoints.newAnonReviewOrderData(this.orderId);
    } else {
      this.headers = {
        'X-Folksy-User-ID': this.user.id,
        'X-Folksy-User-Token': this.user.token,
      };
      this.uri = this.endpoints.newReviewOrderData(this.orderId);
    }
  }

  getData() {
    return rp({
      uri: this.uri,
      headers: this.headers,
      json: true,
    })
      .json();
  }

  saveData(data) {
    return rp({
      uri: this.uri,
      method: 'PUT',
      headers: this.headers,
      body: data,
      json: true,
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reviews/new/gatekeeper.js